import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import useAuth from '../hooks/useAuth';
import { ACTIVE_SUBSCRIPTION_STORE_ID, ME } from '../graphql/User';
import SubscriptionRequiredModal from './SubscriptionRequiredModal';
import { isSubscriptionRoute, shouldRequireSubscription } from '../utils/subscriptionGate';

export default function SubscriptionRequiredGate({ children }) {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();

  const { data: meData, loading: meLoading } = useQuery(ME, {
    skip: !isAuthenticated,
    fetchPolicy: 'cache-and-network',
  });

  const store = meData?.me?.store;
  const storeId = store?.id;

  const { data: subData, loading: subLoading } = useQuery(ACTIVE_SUBSCRIPTION_STORE_ID, {
    variables: { storeId },
    skip: !storeId,
    fetchPolicy: 'cache-and-network',
  });

  const showModal = useMemo(() => {
    if (!isAuthenticated || meLoading || subLoading) return false;
    if (isSubscriptionRoute(pathname)) return false;
    return shouldRequireSubscription(store, subData?.activeSubscriptionByStoreId);
  }, [isAuthenticated, meLoading, subLoading, pathname, store, subData]);

  return (
    <>
      {children}
      <SubscriptionRequiredModal open={showModal} />
    </>
  );
}

SubscriptionRequiredGate.propTypes = {
  children: PropTypes.node,
};
